const BUSINESS_TYPES = [
  {
    label: "Agrarische Handelaar / Boerenwinkel",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Dierenasiel / Goed Doel",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Opfokbedrijf",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Rundvleesproducent",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Vleeskuikens", value: "Broilers", id: "broilers" },
  {
    label: "Inkoopgroep",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Kalfsproductie",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Kalverhouderij/Ontwikkelaar",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Veehandelaar", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contractteler",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Coöperatie", value: "Cooperative", id: "cooperative" },
  {
    label: "Hoofdkantoor",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Koe/Kalf Bedrijf",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Melkveehouderij",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributeur / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Voederfabriek", value: "Feed Mill", id: "feed_mill" },
  { label: "Vleesveebedrijf", value: "Feedyard", id: "feedyard" },
  {
    label: "Teler/Opfokbedrijf",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Broederij", value: "Hatchery", id: "hatchery" },
  {
    label: "Pinkenproductie",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Leghennenintegratie",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Leghennen", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Melkcoöperatie/Koper",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Gemengde/Andere Producent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Voedingsstoffenleverancier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Verpakker/Verwerker",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Dierenwinkel",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apotheek", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Pluimveefokker",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Pluimvee-integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Schapenhouder", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Opfokbedrijf",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Veemarkt/Verkoopstal",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Varkenshouder", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkoenen", value: "Turkeys", id: "turkeys" },
  {
    label: "Universiteit / Onderwijs",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Dierenartspraktijk",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Groothandel / Detailhandel",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wolinkoper", value: "Wool Buyer", id: "wool_buyer" },
];
const FIELDS = {
  common: {
    errors: {
      required: "Verplicht",
    },
  },
  salutation: {
    label: "Aanhef",
    placeholder: "Selecteer Aanhef",
    errors: {
      required: "Aanhef is verplicht",
      invalid: "Selecteer een geldige aanhef",
    },
  },
  firstName: {
    label: "Voornaam",
    placeholder: "Jan",
    errors: {
      required: "Voornaam is verplicht",
      minLength: "Voornaam moet minimaal 2 tekens bevatten",
      maxLength: "Voornaam mag maximaal 50 tekens bevatten",
    },
  },
  lastName: {
    label: "Achternaam",
    placeholder: "De Vries",
    errors: {
      required: "Achternaam is verplicht",
      minLength: "Achternaam moet minimaal 2 tekens bevatten",
      maxLength: "Achternaam mag maximaal 50 tekens bevatten",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "jan.devries@example.org",
    description:
      "Voer een e-mailadres in dat persoonlijk voor u is, geen gedeeld e-mailadres.",
    prefixWarningTitle: "Gedeelde mailbox gedetecteerd",
    prefixWarningDescription:
      "We raden aan een persoonlijk e-mailadres te gebruiken voor een superieure gepersonaliseerde ervaring",
    errors: {
      required: "E-mail is verplicht",
      invalidEmail: "Voer een geldig e-mailadres in",
      emailAssociatedWithYourAccount:
        "Uw e-mailadres is gekoppeld aan uw account en kan niet worden gewijzigd.",
    },
  },
  confirmEmail: {
    label: "E-mail bevestigen",
    placeholder: "jan.devries@example.org",
    errors: {
      required: "E-mail bevestigen is verplicht",
      invalidEmail: "Voer een geldig e-mailadres in",
      emailMatchError: "E-mailadressen komen niet overeen",
    },
  },
  password: {
    label: "Wachtwoord",
    placeholder: "Voer uw wachtwoord in",
    errors: {
      required: "Wachtwoord is verplicht",
    },
  },
  confirmPassword: {
    label: "Wachtwoord bevestigen",
    placeholder: "Bevestig uw wachtwoord",
    errors: {
      required: "Wachtwoord bevestigen is verplicht",
      passwordMatchError: "Wachtwoorden komen niet overeen",
    },
  },
  addressLine1: {
    label: "Adresregel 1",
    placeholder: "Hoofdstraat 123",
    errors: {
      required: "Adresregel 1 is verplicht",
      minLength: "Adresregel 1 moet minimaal 5 tekens bevatten",
      maxLength: "Adresregel 1 mag maximaal 100 tekens bevatten",
    },
  },
  addressLine2: {
    label: "Adresregel 2",
    placeholder: "Appartement 4B",
    errors: {
      required: "Adresregel 2 is verplicht",
      maxLength: "Adresregel 2 mag maximaal 100 tekens bevatten",
    },
  },
  city: {
    label: "Stad / Plaats",
    placeholder: "Amsterdam",
    errors: {
      required: "Stad / Plaats is verplicht",
      minLength: "Stad / Plaats moet minimaal 2 tekens bevatten",
      maxLength: "Stad / Plaats mag maximaal 50 tekens bevatten",
    },
  },
  state: {
    label: "Provincie",
    placeholder: "Selecteer Provincie",
    errors: {
      required: "Provincie is verplicht",
      invalid: "Selecteer een geldige provincie",
    },
  },
  jurisdiction: {
    label: "Jurisdictie van Licentie",
    placeholder: "Selecteer jurisdictie van licentie",
    errors: {
      required: "Jurisdictie van licentie is verplicht",
      invalid: "Selecteer een geldige jurisdictie",
    },
  },
  zipCode: {
    label: "Postcode",
    placeholder: "1234 AB",
    errors: {
      required: "Postcode is verplicht",
      invalid: "Voer een geldige postcode in",
    },
  },
  role: {
    label: "Rol",
    placeholder: "Selecteer uw rol",
    errors: {
      required: "Selecteer uw rol",
      invalid: "Selecteer een geldige rol",
    },
  },
  businessType: {
    label: "Bedrijfstype",
    placeholder: "Selecteer Bedrijfstype",
    errors: {
      required: "Bedrijfstype is verplicht",
      invalid: "Selecteer een geldig bedrijfstype",
    },
  },
  businessName: {
    label: "Bedrijfsnaam",
    placeholder: "Voer bedrijfsnaam in",
    errors: {
      required: "Bedrijfsnaam is verplicht",
      minLength: "Bedrijfsnaam moet minimaal 2 tekens bevatten",
      maxLength: "Bedrijfsnaam mag maximaal 100 tekens bevatten",
    },
  },
  businessSearch: {
    label: "Bedrijfs zoeken:",
    addNewAccount: "Nieuw bedrijfsaccount toevoegen",
    canNotFindBusiness: "Kunt u uw bedrijf niet vinden?",
    guideline:
      "Voer uw postcode in en selecteer vervolgens uit de onderstaande lijst.",
    guidelineForNameSearch:
      "Voer de volledige bedrijfsnaam in en selecteer vervolgens uit de lijst.",
    placeholder: "Waar werkt u?",
    noResults: "Geen resultaten gevonden",
    searching: "Zoeken...",
    selectedBusinessHeading: "Geselecteerd bedrijf:",
    selectedBusinessNotCorrect: "Niet correct?",
    selectedBusinessTryAgain: "Probeer opnieuw",
    selectedBusinessDismiss: "Bedrijf negeren",
    resultsFound: {
      singular: "1 bedrijf gevonden",
      plural: "Meerdere bedrijven gevonden",
    },
    errors: {
      network:
        "We hebben problemen met de verbinding met de bedrijfszoeker. Probeer het later opnieuw.",
    },
  },
  explicitConsent: {
    label:
      "Door dit vakje aan te vinken, ga ik akkoord met de Gebruiksvoorwaarden van Elanco en erken ik dat Elanco mijn persoonlijke gegevens zal verzamelen en verwerken in overeenstemming met de Privacyverklaring van Elanco",
    errors: {
      required: "E-mailtoestemming is verplicht",
    },
  },
  telephone: {
    label: "Persoonlijk telefoonnummer",
    placeholder: "Voer uw persoonlijk telefoonnummer in",
    dialCodeLabel: "Landcode",
    dialCodePlaceholder: "Zoek land…",
    errors: {
      invalid: "Voer een geldig telefoonnummer in.",
    },
  },
  businessTelephone: {
    label: "Zakelijk telefoonnummer",
    placeholder: "Voer uw zakelijk telefoonnummer in",
    dialCodeLabel: "Landcode",
    dialCodePlaceholder: "Zoek land…",
    errors: {
      invalid: "Voer een geldig telefoonnummer in.",
    },
  },
  professionalNumber: {
    label: "Professioneel Nummer",
    placeholder: "1234567",
    errors: {
      required: "Voer een professioneel nummer in",
      maxLength: "Invoer overschrijdt de tekenlimiet",
    },
  },
  addressSearch: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  businessSearchField: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  checkbox: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  combobox: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  datePicker: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  dateRange: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  dateTime: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  emailField: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  fileInput: {
    errors: {
      required: "Selecteer een bestand",
    },
  },
  number: {
    errors: {
      required: "Voer een getal in",
      minValue: "Voer een waarde in die hoger is dan het minimum",
      maxValue: "Voer een waarde in die lager is dan het maximum",
    },
  },
  passwordField: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  rangeSlider: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  select: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  telephoneField: {
    errors: {
      required: "Voer alleen cijfers in",
      invalidTelephone: "Voer een geldig telefoonnummer in",
      invalidFormat: "Ongeldig nummerformaat",
    },
  },
  text: {
    errors: {
      required: "Gebruik alleen letters (A-Z), cijfers (0-9) en geen symbolen",
      maxLength: "Invoer overschrijdt de tekenlimiet",
      minLength: "De invoer moet minimaal 2 tekens lang zijn",
    },
  },
  textarea: {
    characters: "tekens",
  },
  time: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  form: {
    errors: {
      generic:
        "Er is een fout opgetreden bij het verzenden van uw formulier. Probeer het opnieuw.",
      reportAnIssue: "Rapporteer een probleem.",
      configuration: "Configuratiefout",
      noFormQuestionsAvailable: "Geen formuliervragen beschikbaar.",
      formComponentLoad:
        "Formuliercomponent kon niet worden geladen vanwege een niet-ondersteund veld.",
      code: "Code",
      type: "Type",
      missingRequiredFields:
        "Dit formulier mist verplichte velden (E-mail en/of Toestemming). Neem contact op met een beheerder om de formulierconfiguratie te corrigeren.",
    },
  },
};
const ROLES = [
  { value: "Academic", label: "Academicus", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Dierenwelzijn - Overig",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Dierenwelzijn - Winkelpersoneel",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Dierenwelzijn - Dierenarts",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Dierenwelzijn - Dierenartsassistent",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Dierenwelzijn - Vrijwilliger",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Rundvlees / Vleesveebedrijf Voorlichting",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Rundvleesproducent",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Fokker", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Bedrijfsbeheerder / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Bedrijfseigenaar / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consultant Voedingsdeskundige",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Bedrijfsmedewerker (geen dierenarts)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Melkveehouder",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributeur", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributeur Vertegenwoordiger, Buitendienst",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributeur Vertegenwoordiger, Binnendienst",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Onderwijsinstelling - Middelbare Scholier",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Onderwijsinstelling - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Onderwijsinstelling - Universiteitsstudent",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Trimmer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medisch / Kliniek Directeur",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Voeding / Voederverkoop",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Voedingsprofessional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Voedingsdeskundige", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kantoor / Praktijkmanager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apotheker", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apotheek - Personeel",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Varkenshouder", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Pluimveehouder",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praktijkeigenaar (geen dierenarts)",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist / Klantenservice",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Wederverkoper Winkel - Personeel",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Dierenarts",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Dierenarts", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Dierenarts, Praktijkeigenaar",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Dierenartsassistent",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Dierenartsverpleegkundige",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Dierenartspraktijk - Overig",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Dierenartspraktijk - Dierenarts",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Dierenartspraktijk - Dierenartsverpleegkundige",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Dierenartsspecialist",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Dierenartsstudent",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Dierenarts-chirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Dierenartstechnicus",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Groothandel", id: "wholesaler" },
];
const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Mejuffrouw",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Meneer",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Mevrouw",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Mevrouw",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];
export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
